export const getImportPage = state => state.query.importPage;
